const VerifoneContinueTransactionRecord = require('./VerifoneContinueTransactionRecord');

/**
 * This is a "trick" action that does not actually get sent to the terminal, but may be added to the list of possible
 * action buttons that can be pressed by the user.
 * This action will be intercepted by VerifoneDriver and internally reprint the last merchant receipt.
 */
class VerifoneCustomReprintMerchantReceiptRecord extends VerifoneContinueTransactionRecord {
}

module.exports = VerifoneCustomReprintMerchantReceiptRecord;
